import { useCrowdFundingTranslations } from 'core/Hooks';
import { Card, Stack, Text, Title } from 'ui';
import { useCampaignDonationModal, useCrowdfundingProvider } from '../../Context';

export const CampaignDonationConfirmation = () => {
  const { causeId } = useCrowdfundingProvider();
  const { t } = useCrowdFundingTranslations(causeId);
  const { isSuccess, cartType } = useCampaignDonationModal();
  if (!isSuccess) return null;
  return (
    <Card radius={'md'} bg="slate.6">
      <Stack gap={4} align="center">
        <Title order={4} c="white">
          {cartType === 'pledge'
            ? 'Thank You for your Pledge'
            : `Thank You For Your ${t('Donation')}`}
        </Title>
        <Text type="body" c="white" ta="center">
          {cartType === 'pledge'
            ? 'Your card will be charged when the campaign has been finalized'
            : 'You will receive a receipt in your email'}
        </Text>
      </Stack>
    </Card>
  );
};
